<template>
  <!-- <div class="item" @click="goDashBoardRFIDTag">
    <vs-avatar
      size="50px"
      :class="{ active: isActive, inactive: isInactive }"
      :src="img"
    />
    <h5>{{ item.name }} ( {{ item.id }} )</h5>
    <p>Department : {{ item.dept }}</p>
    <p>
      <vs-icon
        icon="trip_origin"
        color="success"
        v-if="item.status != null"
      ></vs-icon
      ><vs-icon icon="trip_origin" color="red" v-else></vs-icon>
      {{ item.status != null ? "Present" : "Absent" }}
    </p>
    <p>Hour in Office : {{ item.timecount }} hr</p>
    <vs-progress :percent="(item.timecount * 100) / 8" color="success"
      >success</vs-progress
    >
  </div> -->
  <div class="item" @click="goDashBoardRFIDTag">
    <div class="item-2-patition">
      <vs-avatar
        size="50px"
        :class="{ active: isActiveCom, inactive: isInactiveCom }"
        :src="img"
      />
      <div>
        <h5>{{ item.name }}</h5>
        <p>Department : {{ item.dept }}</p>
        <p>
          <vs-icon icon="trip_origin" :color="isPresentCom"></vs-icon>
          {{ item.status != null ? "Present" : "Absent" }}
        </p>
        <p>Hour in Office : {{ countToday }} hr</p>
      </div>
    </div>
    <vs-progress :percent="(countToday * 100) / 8" color="success"
      >success</vs-progress
    >
  </div>
</template>

<script>
export default {
  props: {
    item: { type: Object, default: {} },
  },
  data() {
    return {
      isActive: false,
      isInactive: false,
      time: null,
      timeWork: null,
      img: null,
    };
  },
  computed: {
    EmployeeActive: function () {
      if (this.item.status == "in") {
        console.log(this.item);
        return {
          "active-employee": true,
        };
      }
      return {
        "active-employee": false,
      };
    },
    isActiveCom: function () {
      return this.item.status == "in";
    },
    isInactiveCom: function () {
      return this.item.status == "out";
    },
    isPresentCom: function () {
      return this.item.status != null ? "success" : "red";
    },
    countToday: function () {
      console.log(this.item.timestamp);
      if (this.item.timestamp) {
        let today = this.$moment().format("YYYY-MM-DD");
        let datetimestemp = this.item.timestamp.split("T")[0];
        if (today != datetimestemp) {
          return 0;
        }
      }
      return this.item.timecount;
    },
  },
  mounted() {
    console.log(this.item);
    // let today = this.$moment().format("YYYY-MM-DD");
    // let datetimestemp = this.item.timestamp.split("T")[0];
    // if (today == datetimestemp) {
    //   this.item.timecount = 0;
    // }
    this.getImg();
  },
  beforeDestroy() {
    clearInterval(this.time);
  },
  methods: {
    async getImg() {
      if (this.item.image != null && this.item.image != "") {
        let res = await this.$API.get("download/" + this.item.image);
        // console.log(res);
        if (res.status == 200) {
          this.img = res.config.url;
        }
        // console.log(this.img);
      }
    },
    async getRMData() {
      let worktime = 0;
      let today = this.$moment().format("YYYY-MM-DD");

      // get time
      let res = await this.$API.get("iAPC/getdata/" + this.item.tag);
      console.log(res);
      if (res.status == 200) {
        for (let i = 0; i < res.data.length; i++) {
          const el = res.data[i];
          // console.log(el.in_time.split("T")[0]);
          if (el.in_time.split("T")[0] == today) {
            worktime += Number(el.timecount);
          }
        }
        this.timeWork = Math.round((worktime * 100.0) / 3600) / 100;
        // console.log(this.item.status);
        if (this.item.status == "in") {
          this.isActive = true;
          this.isInactive = false;
        } else if (this.item.status == "out") {
          this.isActive = false;
          this.isInactive = true;
        } else {
          this.isActive = false;
          this.isInactive = false;
        }
      }

      console.log(this.item);
    },
    goDashBoardRFIDTag() {
      // this.$router.push({
      //   path: "/DashboardRFIDTag",
      //   query: { tag: this.item.tag },
      // });
    },
  },
};
</script>

<style lang="scss" scoped>
.item {
  border: rgb(201, 201, 201) 2px solid;
  border-radius: 10px;
  // width: 220px;
  // min-width: 220px;
  // max-width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  padding: 10px;
  cursor: pointer;
  p {
    margin-bottom: 0.5rem;
  }
  .item-2-patition {
    // display: flex;
    // align-items: center;
    // justify-content: space-evenly;
    display: grid;
    grid: auto / 60px auto;
    justify-items: start;
    align-items: center;
    width: 100%;
  }
}

.active {
  border: greenyellow 2px solid;
}
.inactive {
  border: red 2px solid;
}
</style>